const magicNumbers = {
  'image/jpeg': {
    signature: [0xff, 0xd8],
    offset: 0,
  },
  'image/png': {
    signature: [0x89, 0x50, 0x4e, 0x47],
    offset: 0,
  },
  'image/gif': {
    signature: [0x47, 0x49, 0x46, 0x38],
    offset: 0,
  },
  'image/heic': {
    signature: [0x66, 0x74, 0x79, 0x70, 0x68, 0x65, 0x69, 0x63],
    offset: 4,
  },
};

const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46]; // %PDF
// The PDF spec permits bytes before the header, and decrypted uploads pick up a leading
// multipart/header prefix — so scan a small window rather than requiring %PDF at offset 0.
const PDF_SCAN_WINDOW = 1024;

const findPdfSignature = (bytes: Uint8Array): boolean => {
  const end = Math.min(bytes.length - PDF_SIGNATURE.length, PDF_SCAN_WINDOW);
  for (let i = 0; i <= end; i++) {
    if (PDF_SIGNATURE.every((byte, j) => bytes[i + j] === byte)) {
      return true;
    }
  }
  return false;
};

// The length guard matters: `.every` on a clamped subarray is vacuously true, so without it
// empty/short inputs would match a signature they don't actually contain.
const matchesSignature = (bytes: Uint8Array, signature: number[], offset: number): boolean =>
  bytes.length >= offset + signature.length && signature.every((byte, i) => bytes[offset + i] === byte);

const detectMimeType = (bytes: Uint8Array): string => {
  for (const [mimeType, { signature, offset }] of Object.entries(magicNumbers)) {
    if (matchesSignature(bytes, signature, offset)) {
      return mimeType;
    }
  }
  if (findPdfSignature(bytes)) {
    return 'application/pdf';
  }
  return 'application/octet-stream';
};

export default detectMimeType;
